import { render, staticRenderFns } from "./CzChoice.vue?vue&type=template&id=3371978d&scoped=true&"
import script from "./CzChoice.vue?vue&type=script&lang=ts&"
export * from "./CzChoice.vue?vue&type=script&lang=ts&"
import style0 from "./CzChoice.vue?vue&type=style&index=0&id=3371978d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371978d",
  null
  
)

export default component.exports